// CRM capability keys — must match the keys the backend returns from
// admin.organizationRoles.getRoles (see utils/organizationRoleCapabilities.js).
export const CRM_CAPABILITY_KEYS = {
  DASHBOARD: 'crm-dashboard',
  CONTACTS: 'crm-contacts',
  ORGANIZATIONS: 'crm-organizations',
  NOTES: 'crm-notes',
  ACTIVITY: 'crm-activity',
  REFERENCE_ITEMS: 'crm-reference-items',
}

// CRM features that expose only the "Can View" toggle (no Edit/Add/Delete).
export const CRM_VIEW_ONLY_KEYS = [
  CRM_CAPABILITY_KEYS.DASHBOARD,
  CRM_CAPABILITY_KEYS.ACTIVITY,
  CRM_CAPABILITY_KEYS.REFERENCE_ITEMS,
]

// Explicit category ordering so "Organization" always renders above "CRM"
// regardless of the order the API returns capabilities in.
// NOTE: these strings are matched case-sensitively against the API's
// `category` value; they must match exactly (e.g. 'Organization', not 'organization').
export const CATEGORY_ORDER = ['Organization', 'Billing', 'CRM']
